import { makeStyles } from '@material-ui/core/styles';
import { calculateHeight, calculateWidth, vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from 'src/mui-theme';

export const styles = makeStyles(() => ({
  closeButton: {
    marginRight: 12,
    fontSize: vh(2.08),
    boxShadow: `0 1px 1px 0 ${themeColor.almosttransparentblack}`,
    border: `1px solid ${themeColor.secondaryLight}`,
    '&:hover': {
      boxShadow: 'none',
      backgroundColor: themeColor.white,
    },
  },
  acceptButton: {
    marginRight: 12,
    fontSize: vh(2.08),
    boxShadow: `0 1px 1px 0 ${themeColor.almosttransparentblack}`,
    '&:hover': {
      boxShadow: 'none',
    },
  },
  rejectButton: {
    fontSize: vh(2.08),
    boxShadow: `0 1px 1px 0 ${themeColor.almosttransparentblack}`,
    '&:hover': {
      boxShadow: 'none',
    },
  },
  dialogContent: {
    backgroundColor: themeColor.lightBackground,
    padding: `0 ${calculateWidth(28).stringValue} ${calculateHeight(28).stringValue}`,
  },
}));
